import axios from "axios";
import { Cookies } from "react-cookie";
import { message } from "antd";
import { Constants } from "./settings";

const _cookies = new Cookies();

axios.defaults.headers.common["fcmToken"] = localStorage["fcmToken"]
  ? localStorage["fcmToken"]
  : "";
axios.defaults.baseURL = Constants.baseUrl;
axios.defaults.headers.common["Authorization"] = `Bearer ${
  _cookies.get("AccessToken") || ""
}`;

const handleError = (error = {}) => {
  switch (error.message) {
    case "Unauthenticated.":
      _cookies.remove("AccessToken", {
        path: "/",
        expires: new Date(1900, 1, 1),
        domain: window.location.hostname,
      });
      window.location = "/account/login";
      break;
    default:
      if (Array.isArray(error.message))
        error.message.forEach((text) => message.error(text));
      else if (error.message) message.error(error.message);
      break;
  }
};

const upload = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, { headers: { "content-type": "multipart/form-data" } })
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const get = (url) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const post = (url, params = {}, skip) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((response) => {
        if (response && response.data) {
          if (skip || response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const put = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const del = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

export default {
  brand: {
    add: (params = {}) => {
      return post(`brand/store`, params);
    },
    delete: (id) => {
      return del(`brand/${id}/destroy`);
    },
    list: () => {
      return get("brand");
    },
    statusUpdate: (params = {}) => {
      return post(
        `brand/${params.id}/statusUpdate?status=${!!params.status ? 0 : 1}`
      );
    },
    update: (params, id) => {
      return post(`brand/${id}/update`, params);
    },
  },
  category: {
    add: (params = {}) => {
      return upload(`category/store`, params);
    },
    list: (params = {}) => {
      let src = `category?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.type) src = `${src}&type=${params.type}`;

      if (params.parentId) src = `${src}&parentId=${params.parentId}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return put(
        `category/${params.id}/statusUpdate?status=${
          !!parseInt(params.status) ? 0 : 1
        }`
      );
    },
    delete: (params = {}) => {
      return del(`category/${params.id}/destroy`);
    },
    update: (params, id) => {
      return upload(`category/${id}/update`, params);
    },
  },
  bank: {
    add: (params = {}) => {
      return upload(`bank/store`, params);
    },
    list: (params = {}) => {
      let src = `bank?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      return get(src);
    },

    delete: (params = {}) => {
      return del(`bank/${params.id}/destroy`);
    },
    update: (params, id) => {
      return upload(`bank/${id}/update`, params);
    },
  },
  dashboard: {
    list: () => {
      return get("dashboard");
    },
  },
  message: {
    add: (params = {}) => {
      return post(`message/store`, params);
    },
    addDraft: (params = {}) => {
      return post(`draft/store`, params);
    },
    list: (params = {}) => {
      let src = `message?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    delete: (id) => {
      return del(`message/${id}/destroy`);
    },
    deleteDraft: (id) => {
      return del(`draft/${id}/destroy`);
    },
    draftList: (params = {}) => {
      let src = `draft?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    updateDraft: (params, id) => {
      return post(`draft/${id}/update`, params);
    },
  },
  offer: {
    add: (params = {}) => {
      return post(`special/store`, params);
    },
    list: (params = {}) => {
      let src = `special?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return post(
        `special/${params.id}/updateStatus?status=${
          !!parseInt(params.status) ? 0 : 1
        }`
      );
    },
    delete: (params = {}) => {
      return del(`special/${params.id}/destroy`);
    },
    update: (params, id) => {
      return post(`special/${id}/update`, params);
    },
  },
  order: {
    add: (params = {}) => {
      return post(`cart/store`, params);
    },
    delete: (id) => {
      return del(`cart/${id}/destroy`);
    },
    getExcelOrder: (id) => {
      return get(`cart/${id}/getExcelOrder`);
    },
    list: (params = {}) => {
      let src = `cart?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      if (params.orderType) src = `${src}&orderType=${params.orderType}`;

      if (params.payStatus) src = `${src}&paymentStatus=${params.payStatus}`;

      if (params.payType) src = `${src}&paymentType=${params.payType}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;

      if (params.status) src = `${src}&status=${params.status}`;

      if (params.country_id) src = `${src}&country_id=${params.country_id}`;
      if (params.admin_status != null) src = `${src}&admin_status=${params.admin_status}`;
      if (params.id != null) src = `${src}&id=${params.id}`;

      
      return get(src);
    },
    update: (params, id) => {
      return post(`cart/${id}/update`, params);
    },

    changeAdminStatus: (order, params) => {
      return post(`cart/${order.id}/change_status`, params);
    }
  },

  searchReport: {
    list: (params = {}) => {
      let src = `search/report?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;

      
      return get(src);
    },
    detail: (params = {}) => {
      let src = `search/report/detail?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;
      if (params.user_id) src = `${src}&user_id=${params.user_id}`;
      
      return get(src);
    },
  },
  advanceSearchReport: {
    list: (params = {}) => {
      let src = `search/report/advance?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.time) src = `${src}&time=${params.time}`;

      return get(src);
    },
    detail: (params = {}) => {
      let src = `search/report/advance/detail?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.time) src = `${src}&time=${params.time}`;

      return get(src);
    },
  },
  country: {

    list: (params = {}) => {
      let src = `country/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;


      return get(src);
    },

    add: (params = {}) => {
      return post(`country/store`, params);
    },

    update: (params, id) => {
      return post(`country/${id}/update`, params);
    },
    delete: (id) => {
      return del(`country/${id}/destroy`);
    },
  },


  logisticsSchedule: {

    list: (params = {}) => {
      let src = `logisticsSchedule/list?q=${params.q || ""}`;
      if (params.page) src = `${src}&page=${params.page}`;
      if (params.country_id) src = `${src}&country_id=${params.country_id}`;
      if (params.city_id) src = `${src}&city_id=${params.city_id}`;
      if (params.neighborhood_id) src = `${src}&neighborhood_id=${params.neighborhood_id}`;
      return get(src);
    },

    store: (params = {}) => {
      return post(`logisticsSchedule/store`, params);
    },

    update: (params, id) => {
      return post(`logisticsSchedule/${id}/update`, params);
    },
    delete: (id) => {
      return del(`logisticsSchedule/${id}/destroy`);
    },

    StorBaseNotifInfo: (params = {}) => {
      return post(`logisticsSchedule/baseNotifInfo`, params);
    },
  },


  city: {

    list: (country, params = {}) => {
      let src = `city/list/${country}?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;


      return get(src);
    },

    add: (params = {}) => {
      return post(`city/store`, params);
    },

    update: (params, id) => {
      return post(`city/${id}/update`, params);
    },
    delete: (id) => {
      return del(`city/${id}/destroy`);
    },
  },

  aiPromptSetting: {
    list: () => get('/ai-prompt-settings'),
    create: (data) => post('/ai-prompt-settings', data),
    update: (id, data) => put(`/ai-prompt-settings/${id}`, data),
    delete: (id) => del(`/ai-prompt-settings/${id}`)
},

  neighborhood: {

    list: (city, params = {}) => {
      let src = `neighborhood/list/${city}?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;


      return get(src);
    },

    add: (params = {}) => {
      return post(`neighborhood/store`, params);
    },

    update: ( id, params) => {
      return post(`neighborhood/${id}/update`, params);
    },
    delete: (id) => {
      return del(`neighborhood/${id}/destroy`);
    },
  },
  reminder_pay: {

    list: (params = {}) => {
      let src = `reminder_pay/list?`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.date) src = `${src}&date=${params.date}`;
      if (params.from_date) src = `${src}&from_date=${params.from_date}`;
      if (params.to_date) src = `${src}&to_date=${params.to_date}`;
      if (params.regsitrar) src = `${src}&regsitrar=${params.regsitrar}`;
      if (params.user) src = `${src}&user=${params.user}`;
      if (params.is_pay) src = `${src}&is_pay=${params.is_pay}`;
      if (params.city) src = `${src}&city=${params.city}`;


      return get(src);
    },

    add: (params = {}) => {
      return post(`reminder_pay/store`, params);
    },

    update: (params, id) => {
      return post(`reminder_pay/${id}/update`, params);
    },
    delete: (id) => {
      return del(`reminder_pay/${id}/destroy`);
    },
    payed: (id) => {
      return get(`reminder_pay/${id}/payed`);
    },
    sendsms: (params, id) => {
      return post(`reminder_pay/${id}/sendsms`, params);
    },
  },

  remittance: {

    list: (params = {}) => {
      let src = `remittance/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;


      return get(src);
    },

  },
  postman: {
    list: () => {
      return get("postman/getLocation");
    },
    report: (params = {}) => {
      return get(
        `postman/${params.id}/predictedDistance?fromDate=${params.fromDate}&toDate=${params.toDate}`
      );
    },
  },
  product: {
    addImage: (params = {}) => {
      return upload(`product/images/store`, params);
    },
    list: (params = {}) => {
      let src = `product?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.image) src = `${src}&image=${params.image}`;

      if (params.category) src = `${src}&category=${params.category}`;

      if (params.code) src = `${src}&code=${params.code}`;

      if (params.isVip) src = `${src}&isVip=${params.isVip}`;
      if (params.hasPrice) src = `${src}&hasPrice=${params.hasPrice}`;

      if (params.categoryId) src = `${src}&category_id=${params.categoryId}`;

      if (params.subCategoryId)
        src = `${src}&subCategory_id=${params.subCategoryId}`;
      if (params.supplier_id) src = `${src}&supplier_id=${params.supplier_id}`;

      if (params.search_type) src = `${src}&search_type=${params.search_type}`;

      

      return get(src);
    },
     excelExport: (params = {}) => {
          let src = `product/export/excel?q=${params.q || ""}`;

          if (params.supplier_id) src = `${src}&supplier_id=${params.supplier_id}`;
          if (params.categoryId) src = `${src}&category_id=${params.categoryId}`;
          if (params.search_type) src = `${src}&search_type=${params.search_type}`;

        if (params.subCategoryId)
          src = `${src}&subCategory_id=${params.subCategoryId}`;

            return get(src);
          },
    statusUpdate: (product, params = {}) => {
      return post(
        `product/${product.id}/StatusUpdate`, params
      );
    },

    vipUpdate: (params = {}) => {
      return post(
        `product/${params.id}/VipUpdate?isVip=${
          !!parseInt(params.isVip) ? 0 : 1
        }`
      );
    },
    deleteImage: (id = {}) => {
      return del(`product/images/${id}/destroy`);
    },
    update: (params, id) => {
      return upload(`product/${id}/update`, params);
    },
    save: (params) => {
      return upload(`product/save`, params);
    },
    excelUpload: (params = {}) => {
      return post(`/exel`, params);
    },
  },
  question: {
    add: (params = {}) => {
      return post(`question/store`, params);
    },
    delete: (id) => {
      return del(`question/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `question?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`question/${id}/update`, params);
    },
  },
  setting: {
    list: () => {
      return get("setting");
    },
    update: (params) => {
      return upload(`setting/update`, params);
    },
  },
  slider: {
    add: (params = {}) => {
      return post(`slider/store`, params);
    },
    delete: (id) => {
      return del(`slider/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `slider?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return post(
        `slider/${params.id}/statusUpdate?status=${!!params.status ? 0 : 1}`
      );
    },
    update: (params, id) => {
      return post(`slider/${id}/update`, params);
    },
  },
  tag: {
    add: (params = {}) => {
      return post(`tag/store`, params);
    },
    delete: (id) => {
      return del(`tag/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `tag?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`tag/${id}/update`, params);
    },
  },
  package: {
    add: (params = {}) => {
      return post(`package/store`, params);
    },
    delete: (id) => {
      return del(`package/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `package/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`package/${id}/update`, params);
    },
  },
  user: {
    add: (params = {}) => {
      return post(`user/store`, params);
    },
    delete: (params = {}) => {
      return del(`user/${params.id}/destroy`);
    },
    details: (id) => {
      return get(`user/${id}`);
    },
    list: (params = {}) => {
      let src = `user?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.user_type) src = `${src}&user_type=${params.user_type}`;
      if (params.country_id) src = `${src}&country_id=${params.country_id}`;

      if (params.level && params.level.length)
        params.level.forEach((o) => {
          src = `${src}&level[]=${o}`;
        });

      return get(src);
    },
    me: () => {
      return get("auth/me");
    },
    update: (params, id) => {
      return put(`user/${id}/update`, params);
    },

    preventSendProductsToApp: (id, params) => {
      return post(`user/${id}/prevent_send_products_to_app`, params);
    },

    
    increaseCredit: (params = {}) => {
      return post(`user/${params.id}/chargeAccount`, params);
    },
    decreaseCredit: (params = {}) => {
      return post(`user/${params.id}/removalAccount`, params);
    },
    permissionUpdate: (params = {}) => {
      return post(`user/${params.id}/permissionUpdate`, params);
    },
    statusUpdate: (params = {}) => {
      return put(
        `user/${params.id}/StatusUpdate?status=${
          !!parseInt(params.status) ? 0 : 1
        }`
      );
    },
    vipUpdate: (params = {}) => {
      return put(
        `user/${params.id}/VipUpdate?isVip=${!!parseInt(params.isVip) ? 0 : 1}`
      );
    },
    login: (params = {}) => {
      return post("auth/login", params, true);
    },
    verify: (params = {}) => {
      return post("auth/verify", params, true);
    },
    search: (params = {}) => {
      let src = `user/search?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
  },
  voip: {
    distance: (params = {}) => {
      return post("location/getDistance", params);
    },
    user: (params = {}) => {
      return get(`voip/search?phone=${params.phone}`);
    },
    products: (params = {}) => {
      return post("voip/search/product", params);
    },
  },
  downloadApp: {
    list: () => {
      return get("downloadApp/list");
    },
    add: (params = {}) => {
      return post("downloadApp/save", params);
    },
    update: (params = {}) => {
      return post("downloadApp/update", params);
    },
    detail: {
      list: () => {
        return get("downloadApp/detail/list");
      },
      save: (params = {}) => {
        return post("downloadApp/detail/save", params);
      },
    },
  },


  userExperience: {
    list: (params = {}) => {
      return get(`experiences?user_id=${params.user_id}`);
    },
    store: (params = {}) => {
      return post(`experiences`, params);
    },
    update: (id, params = {}) => {
      return put(`experiences/${id}`, params);
    },

    show: (id, params = {}) => {
      return get(`experiences/show/${id}`, params);
    },

    analyze: (params = {}) => {
      return get(`experiences/analyze?user_id=${params.user_id}`);
    },
  },
};
